import { IconLayer } from '@deck.gl/layers';

export type RotorClock = { nowMs: number };

export type AnimatedRotorLayerExtraProps = {
  clock: RotorClock;
};

/**
 * Deck.GL IconLayer that advances its clock and keeps itself dirty so that animation continues.
 */
export class AnimatedRotorLayer<DataT = unknown> extends IconLayer<
  DataT,
  AnimatedRotorLayerExtraProps
> {
  static layerName = 'AnimatedRotorLayer';

  static defaultProps = {
    ...IconLayer.defaultProps,
    clock: { type: 'object' as const, value: { nowMs: 0 } },
  };

  draw(params: Parameters<IconLayer['draw']>[0]): void {
    const { clock } = this.props;

    clock.nowMs = performance.now();
    this.getAttributeManager()?.invalidate('instanceAngles');

    // This is necessary to get Deck.GL to respect the invalidation above - without it,
    // rotors only animate when some other animation trigger occurrs (ie, map is zoomed).
    // eslint-disable-next-line no-underscore-dangle
    this._updateAttributes();

    super.draw(params);

    // Continue the animation.
    this.setNeedsRedraw();
  }
}
